export enum TwoFactorTypeEnum {
  None = 0,
  App = 1,
  Email = 2,
  SMS = 3,
}
